import { makeStyles } from '@material-ui/core/styles';

export const useFormChangePasswordStyles = makeStyles(theme => ({
  form: {
    flexGrow: 1
  }
}));
